import { Shark, Utils, View } from "shark-mvc";

import Client from "../../_shark_models/Client";
import ViewBase from "../ViewBase";

import templateContent from "./client-list.html";

import contactManageView from "./contactManageView";
import clientEditView from "./clientEditView";
import { clientFullRecapComponent } from "../visits/clientFullRecapComponent";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class ClientListView extends ViewBase {
	constructor () {
		super("clientListView");
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		followUpComponent.set("targetItem", null);
		liveSearchComponent.behavior = "database";
		liveSearchComponent.set({searchHint: "Il testo inserito verrà cercato nel nome del contatto, nell'indirizzo, nel codice."})
	
		let provinceForFilterComponent = Shark.get("provinceList").map(item => item.label);
		provinceForFilterComponent.sort();
		provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});
		Shark.set({provinceForFilterComponent});

		provinceFilterComponent.behavior = "database";

		if (Shark.get("clientList").length === 0) {
			this.refreshList();
		}

		this.set({
			__htmlTitle: "Contatti | IPM HUB",
		});
	}

	createNewClientBtn_clickHandler () {
		Shark.set({
			editingClient: new Client(),
			__isEditing: true,
		});
	
		Shark.openPage(clientEditView);
	}
	
	deleteContactBtn_clickHandler (event, data) {
		const currUser = Shark.get("currUser");
		const selectedContact = Utils.safp(Shark.get("clientList"), "guid", data.guid);
		
		if (selectedContact) {
			const userMessage = prompt(`Sei sicur${currUser.getGenderLastLetter()} di voler cancellare il Contatto ${selectedContact.name}?\n\nSe prosegui non sarà possibile annullare, prima di proseguire dovresti verificare che non ci siano Progetti legati a questo contatto (il sistema non verifica ancora in automatico).\n\nSe vuoi cancellare il contatto, per favore, scrivi "elimina" qui sotto:`);

			if (userMessage) {
				if (userMessage.toLowerCase() === "elimina") {
					clientManager.delete(selectedContact)
					.then(response => {
						this.refreshList();
					});
				}
				else {
					alert("Mi spiace, per confermare la cancellazione devi scrivere 'elimina'.");
				}
			}
		}
	}

	init () {
		this.addComponents([clientFullRecapComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, provinceFilterComponent, refreshListButtonComponent, waitBoxComponent]);
		
		const contactListActiveFilters = Shark.getInstance("__smart__", {
			showClients: true,
			showLeads: true,
			showOthers: true,
			showProspects: true,

			showActive: true,
			showArchived: false,
		});
	
		contactListActiveFilters.on("dataChanged", function (event, data) {
			if (this.showClients || this.showLeads || this.showOthers || this.showProspects) {
				clientListView.refreshList();
			}
			else {
				Shark.set({
					clientList: [],
					__clientListNeedFurtherLoad: false,
				});
			}
		});
	
		Shark.set({
			clientList: Shark.get("clientList") || [],
			contactListActiveFilters,
		}); 

		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};
	}

	navAdvancedClientManagementBtn_clickHandler () {
		if (confirm("Attenzione!\n\nIn questa sezione troverai opzioni e attività che potrebbero creare seri problemi se non usati con estrema cautela, fai attenzione a quello che fai!")) {
			Shark.openPage(contactManageView);
		}
	}

	refreshList (range = null) {
		const [contactListActiveFilters, provinceFilter] = Shark.get(["contactListActiveFilters", "provinceFilter"]);
		const filters = contactListActiveFilters.export();

		if (!filters.showClients && !filters.showLeads && !filters.showOthers && !filters.showProspects) {
			console.warn("Nessun tipo da cercare");
			refreshListButtonComponent.resetStatus();
			return Promise.resolve();
		}

		waitBoxComponent.show();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		// delete filters.showClients;
		// delete filters.showLeads;
		// delete filters.showOthers;
		// delete filters.showProspects;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		// if (agentFilter.agentGuid !== "") {
		// 	filters.agentGuid = agentFilter.agentGuid;
		// }

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		if (Shark.get("currUser").hasPermission("manageClients")) {
			return clientManager.getFilteredList({filters, range, incrementalRequest})
			.then(response => {
				waitBoxComponent.hide();

				const clientList = Shark.get("clientList");
				clientList.forEach((item, index) => item.__displayIndex = index + 1);

				followUpComponent.set({
					sourceList: clientList,
				});

				Shark.render();//Questi non dovrebbero servire...
				return true;
			});
		}
		else {
			return clientManager.getListByGuid(Shark.get("currUser").guid)
			.then(() => {
				waitBoxComponent.hide();

				const clientList = Shark.get("clientList");
				clientList.forEach((item, index) => item.__displayIndex = index + 1);

				followUpComponent.set({
					sourceList: clientList,
				});
				Shark.render();//Questi non dovrebbero servire...
				return true;
			});
		}
	}

	updateTextFilters (searchKey) {
		this.textFilters = {
			address: searchKey,
			code: searchKey,
			name: searchKey,
		};

		this.refreshList()
		.then(() => {
			liveSearchComponent.setFocus();
		});
	}



	
	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}

		const selectedClient = Utils.safp(Shark.get("clientList"), "guid", data.guid);
		followUpComponent.set("targetItem", selectedClient);

		Shark.set({
			editingClient: selectedClient,
			__isEditing: false,
		});
		Shark.openPage(clientEditView);
	}
}

const clientListView = new ClientListView();

Shark.registerView(clientListView);

export default clientListView;
